import $ from 'wee-dom';
import $screen from 'wee-screen';
import { RouteHandler } from 'wee-routes';

export default new RouteHandler({
	init() {
		const $message = $('.banner__message');
		let $msgContainer = $('.banner__message-container');

		$screen.map({
			min: 1,
			callback() {
				let height = 0;

				$message.each((el) => {
					const $el = $(el);
					const width = $el.width() / 2;

					$el.css('left', `calc(50% - ${width}px)`);

					if ($el.height() > height) {
						height = 20 + 'px';
					}
				});

				$msgContainer.height(height);
			},

			min: 3,
			each: true,
			callback() {
				setInterval(() => {
					$message.each((el) => {
						const $el = $(el);

						$el.hasClass('-visible') ? $el.removeClass('-visible').addClass('-disappear') :
							$el.removeClass('-disappear').addClass('-visible');
					});
				}, 6000);
			}
		});
	}
});